import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-white py-10 border-t border-white/5" data-id="element-70">
      <div className="container mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-71">
        <div className="text-center md:text-left" data-id="element-72">
          <a href="#" data-id="element-73">
            <img src="https://code-11.hr/wp-content/uploads/2023/03/logo-i-tekst-1.png" alt="Code 11" className="h-16 w-auto" data-id="element-74" />
          </a>
        </div>

        <div className="text-white/30 font-sans text-[10px] tracking-widest uppercase" data-id="element-75">
          &copy; {new Date().getFullYear()} Code 11. All rights reserved.
        </div>

        <a href="https://www.instagram.com/code11hvar/" target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-white transition-colors font-sans text-[10px] uppercase tracking-[0.2em]" data-id="element-76">
          Instagram
        </a>
      </div>
    </footer>;
}